import { orchestrator } from 'satcheljs';
import getRoomFreeBusy from '../utils/getRoomFreebusy';
import type { CalendarEventTime } from '../components/RoomSelector/RoomSelector.types';
import { fetchRoomsAvailability } from '../actions/calendarRoomActions';

export default orchestrator(fetchRoomsAvailability, async actionMessage => {
    const {
        rooms,
        freeBusyCache,
        eventStartDateTime,
        eventEndDateTime,
        isAllDayEvent,
        recurrence,
        requiredAttendees,
        optionalAttendees,
        filter,
    } = actionMessage;

    if (!rooms || rooms.length == 0 || !freeBusyCache) {
        return;
    }

    const calendarEventTime: CalendarEventTime = {
        Start: eventStartDateTime,
        End: eventEndDateTime,
        IsAllDayEvent: isAllDayEvent,
        Recurrence: recurrence,
        RequiredAttendees: requiredAttendees,
        OptionalAttendees: optionalAttendees,
    };

    // Prefetch availability for rooms
    rooms.forEach(room =>
        getRoomFreeBusy(room.email, freeBusyCache, calendarEventTime, room.bookingType, filter)
    );
});
